import { render, staticRenderFns } from "./TableFee.vue?vue&type=template&id=0c58274d"
import script from "./TableFee.vue?vue&type=script&lang=js"
export * from "./TableFee.vue?vue&type=script&lang=js"
import style0 from "./TableFee.vue?vue&type=style&index=0&id=0c58274d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports